import { createSelector } from 'reselect';

const selectSmsPlans = (state: any) => state.smsPlans;


export const selectSmsPlansCurrentItem = createSelector([selectSmsPlans], (smsPlans) => smsPlans.current);

export const selectSmsPlansListItems = createSelector([selectSmsPlans], (smsPlans) => smsPlans.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectSmsPlansListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSmsPlansCreatedItem = createSelector([selectSmsPlans], (smsPlans) => smsPlans.create);
export const selectSmsPlansQueryItems = createSelector([selectSmsPlans], (smsPlans) => smsPlans.query);
export const selectSmsPlansUpdatedItem = createSelector([selectSmsPlans], (smsPlans) => smsPlans.update);

export const selectSmsPlansReadItem = createSelector([selectSmsPlans], (smsPlans) => smsPlans.read);

export const selectSmsPlansDeletedItem = createSelector([selectSmsPlans], (smsPlans) => smsPlans.delete);

export const selectSmsPlansSearchedItems = createSelector([selectSmsPlans], (smsPlans) => smsPlans.search);

export const selectSmsPlansItemsCount = createSelector([selectSmsPlans], (smsPlans) => smsPlans.count);

export const selectSmsPlansItemsFilter = createSelector([selectSmsPlans], (smsPlans) => smsPlans.filter);